import { useAtomValue } from "jotai";
import { FormValuesStore } from "../stores/formValuesStore";

export function useFormValues() {
  return useAtomValue(FormValuesStore);
}
